import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
    selector: 'input[onlyNumbers]'
})
export class OnlyNumbers {

    private elNg: NgControl;

    constructor(private ngControl: NgControl) {
        this.elNg = ngControl;
    }

    @HostListener('input', ['$event.target.value'])
    onInput(value: string) {
        this.elNg.control.patchValue(value.replace(/[^0-9]/g, ''));
    }
  
}
